



























































import Onboarding from '@/util/Onboarding'
import { Vue, Component } from 'vue-property-decorator'
import { setPageTitle } from '@/util/Helpers'
import VPage from '@/components/pages/VPage.vue'

interface InputValue {
    value: string
    error: string | null
}

@Component({ name: 'link-device', components: { VPage } })
export default class Link extends Vue {
    public email: InputValue = { value: '', error: null }
    public secretKey: InputValue = { value: '', error: null }
    public password: InputValue = { value: '', error: null }

    mounted(): void {
        setPageTitle('Link account')
    }

    public tabWhenFull(id: number): void {
        // if (this.secretKeyParts[id].length === 4 && id !== 3) {
        //     (this.$refs[`secretKey${id + 1}`] as HTMLElement).focus()
        // }
        // if (this.secretKeyParts[id].length === 0 && id !== 0) {
        //     (this.$refs[`secretKey${id - 1}`] as HTMLElement).focus()
        // }
    }

    update(key: 'email' | 'secretKey' | 'password', value: string): void {
        this[key].error = null
        this[key].value = value
    }

    public async link() {
        if (this.email.value === '') {
            this.email.error = 'Email is empty'
        }
        if (this.secretKey.value === '') {
            this.secretKey.error = 'Secret key is empty'
        }
        if (this.password.value === '') {
            this.password.error = 'Password is empty'
            return
        }

        if (this.secretKey.value.length !== 19) {
            this.secretKey.error = 'Key must be in the form of 0000-0000-0000-0000'
            return
        }

        const emailCheck = await Onboarding.checkEmail(this.email.value)
        if (emailCheck.valid) {
            this.email.error = 'No matching email found'
            return
        }

        if (await Onboarding.link(this.email.value, this.secretKey.value, this.password.value)) {
            this.$router.push('/')
        } else {
            this.password.error = 'Incorrect secret key or password. Please double check and try again.'
        }
    }
}
